import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import _get from 'lodash/get';
import ContactListItem from 'components/Contacts/ContactListItem';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import dropdownNavigation from 'components/Dropdown/DropdownNavigation';
import OneTimeMeeting, { ONE_TIME_LIST_ITEM } from 'models/OneTimeMeeting';
import ReactInfinite from 'react-infinite';
import ReactDOM from 'react-dom';
import classes from './ScheduleSearchResults.module.scss';

const ELEMENT_HEIGHT = 42;

const messages = defineMessages({
  oneTimeResult: { id: 'search.schedule.oneTime', defaultMessage: 'New one-time meeting' }
});

class ScheduleSearchResults extends React.Component {
  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.selectionIndex > this.props.selectionIndex) {
      this.scrollToNextResult();
    }

    if (nextProps.selectionIndex < this.props.selectionIndex) {
      this.scrollToPreviousResult();
    }
  }

  /* eslint-disable react/no-find-dom-node */
  getScrollTop = () => ReactDOM.findDOMNode(this).scrollTop;

  setScrollTop = (scrollTop) => {
    ReactDOM.findDOMNode(this).scrollTop = scrollTop;
  };
  /* eslint-enable react/no-find-dom-node */

  scrollToNextResult = () => {
    const highlightedIndex = this.props.selectionIndex + 2;
    if (highlightedIndex * ELEMENT_HEIGHT > this.getScrollTop() + this.props.maxItems * ELEMENT_HEIGHT) {
      this.setScrollTop((highlightedIndex - this.props.maxItems) * ELEMENT_HEIGHT);
    }
  };

  scrollToPreviousResult = () => {
    const highlightedIndex = this.props.selectionIndex - 1;
    if (highlightedIndex * ELEMENT_HEIGHT < this.getScrollTop()) {
      this.setScrollTop(highlightedIndex * ELEMENT_HEIGHT);
    }
  };

  render() {
    const {
      currentUser,
      handleSelectContact,
      maxItems,
      searchString,
      selectionIndex,
      searchResults,
      showOneTimeMeetings
    } = this.props;

    const emptyState = !_get(searchResults, 'length') && searchString;

    let returnArray = [];

    if (emptyState) {
      returnArray = <EmptyMessage />;
    } else {
      let arrayShift = 0;

      if (showOneTimeMeetings) {
        returnArray.push(
          <ContactListItem
            key={ONE_TIME_LIST_ITEM}
            className={classes.listItem}
            contact={
              new OneTimeMeeting({
                name: this.props.intl.formatMessage(messages.oneTimeResult)
              })
            }
            matches={[]}
            handleSelectContact={handleSelectContact}
            isHighlighted={selectionIndex === 0}
            isFirstContact
            isBold
            fontSize="1.1em"
            noButtons
            dataTestTag="schedule-newOneTime"
          />
        );

        arrayShift = 1;
      }

      returnArray.push(
        <ContactListItem
          key={currentUser.id}
          className={classes.listItem}
          contact={currentUser}
          matches={[]}
          handleSelectContact={handleSelectContact}
          isHighlighted={selectionIndex === arrayShift}
          isFirstContact
          isSelf
          fontSize="1.1em"
          noButtons
          dataTestTag="schedule-self"
        />
      );

      returnArray = returnArray.concat(
        searchResults.map((result, index) => (
          <ContactListItem
            key={result.contact ? result.contact.id : result.id}
            className={classes.listItem}
            contact={result.contact ? result.contact : result}
            matches={result.matches ? result.matches.name : []}
            handleSelectContact={handleSelectContact}
            isHighlighted={index === selectionIndex - (1 + arrayShift)}
            isFirstContact={false}
            isSelf={false}
            fontSize="1.1em"
            noButtons
            dataTestTag="schedule-contact"
          />
        ))
      );
    }

    return (
      <ReactInfinite
        className={classes.infiniteScroll}
        containerHeight={maxItems * ELEMENT_HEIGHT}
        elementHeight={ELEMENT_HEIGHT}
        styles={
          emptyState
            ? {
                scrollableStyle: {
                  display: 'flex',
                  justifyContent: 'center',
                  width: '466px',
                  overflowY: 'auto',
                  height: 'auto'
                }
              }
            : { scrollableStyle: { overflowY: 'auto' } }
        }
      >
        {returnArray}
      </ReactInfinite>
    );
  }
}

ScheduleSearchResults.propTypes = {
  currentUser: PT.object,
  handleSelectContact: PT.func.isRequired,
  searchString: PT.string,
  maxItems: PT.number,
  selectionIndex: PT.number,
  searchResults: PT.array,
  searchResultCount: PT.number,
  intl: PT.object,
  showOneTimeMeetings: PT.bool
};

export default dropdownNavigation(injectIntl(ScheduleSearchResults));
